/**
 * Lista de Tipos de Desagregação que não geram o GRÁFICO
 */
export const GRAPH_UNAGG_NALLOW_TERRITORIES = [
    'country',
    'region_city',
    'state_city',
    //'region_undefined',
    //'state_undefined',
    //'country_undefined'
]


// WEBPACK FOOTER //
// ./src/logic/ResearchConfig.js